module.exports = __webpack_public_path__ + "/images/logo-fr-berceau-magique.a6a16b1.png";